import { useEffect, useState } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import SeasonOverview from '@/pages/home/components/SeasonOverview';
import RecommendationGrid from '@/pages/home/components/RecommendationGrid';
import CollectionsSection from '@/pages/home/components/CollectionsSection';
import ScheduleSection from '@/pages/home/components/ScheduleSection';
import GenreSection from '@/pages/home/components/GenreSection';
import RankingSection from '@/pages/home/components/RankingSection';
import WatchlistSection from '@/pages/home/components/WatchlistSection';
import FaqSection from '@/pages/home/components/FaqSection';
import GuideSection from '@/pages/home/components/GuideSection';
import Footer from '@/pages/home/components/Footer';

const STORAGE_KEY = 'yaojing-watchlist';

function readWatchlist(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export default function Home() {
  const [watchlist, setWatchlist] = useState<string[]>(readWatchlist);
  const [activeSeason, setActiveSeason] = useState('全部');
  const [activeGenre, setActiveGenre] = useState('全部');

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(watchlist));
    } catch {
      // ignore storage failures
    }
  }, [watchlist]);

  const toggleWatch = (id: string) => {
    setWatchlist((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Navbar watchCount={watchlist.length} />
      <main>
        <Hero />
        <SeasonOverview />
        <RecommendationGrid
          activeSeason={activeSeason}
          onSeasonChange={setActiveSeason}
          activeGenre={activeGenre}
          onGenreChange={setActiveGenre}
          watchlist={watchlist}
          onToggleWatch={toggleWatch}
        />
        <CollectionsSection />
        <ScheduleSection />
        <GenreSection activeGenre={activeGenre} onSelectGenre={setActiveGenre} />
        <RankingSection />
        <WatchlistSection watchlist={watchlist} onToggleWatch={toggleWatch} />
        <FaqSection />
        <GuideSection />
      </main>
      <Footer />
    </div>
  );
}